import { render, staticRenderFns } from "./ErrorGoodLimit.vue?vue&type=template&id=81ec47c2&"
import script from "./ErrorGoodLimit.vue?vue&type=script&lang=js&"
export * from "./ErrorGoodLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports